import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const linkStyle = {
  textDecoration: "none",
};


const Footer = () => {
    return (
      <div className='bg'>
      <div className='footer'>
        <div className='footergrid'>
          <div className='footercol'>
            <p>Free For Limited Time</p>
            <h2>Access All Platform</h2>
            <p>Terms & conditions | Privacy</p>
          </div>
          <div className='footercol'>
            <h3>Languages</h3>
            <Link to = "/html" style={linkStyle}>HTML</Link>
            <Link to = "/css" style={linkStyle}>CSS</Link>
            <Link to = "/js" style={linkStyle}>Javascript</Link>
         </div>
         <div className='footercol'>
           <h3>Support</h3>
           <a href='#'>Contact us</a>
         </div>
         <div className='footercol'>
          <h3>Company</h3>
          <a href='#'>Be a mentor</a>
          <a href='#'>We are hiring!</a>
         </div>
        </div>
     </div>
     </div>
);
};

export default Footer;